import FingerprintJS from '@fingerprintjs/fingerprintjs'

let cachedFingerprint: string | null = null
let cachedToken: string | null = null
let tokenExpiration: number | null = null

export const getFingerprint = async (): Promise<string> => {
  if (cachedFingerprint) return cachedFingerprint

  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    cachedFingerprint = result.visitorId
    return cachedFingerprint
  } catch {
    return ''
  }
}

export const generateFingerprintToken = async (): Promise<string> => {
  try {
    if (cachedToken && tokenExpiration && Date.now() < tokenExpiration) {
      return cachedToken
    }

    const fingerprint = await getFingerprint()
    if (!fingerprint) return ''

    // Chamar API route para gerar token de forma segura
    const response = await fetch('/api/fingerprint/generate-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        fingerprint
      })
    })

    if (!response.ok) {
      console.error(
        'Failed to generate fingerprint token:',
        response.statusText
      )
      return ''
    }

    const { token } = await response.json()

    if (!token) {
      return ''
    }

    cachedToken = token
    tokenExpiration = Date.now() + 24 * 60 * 60 * 1000
    return token
  } catch (error) {
    console.error('Error generating fingerprint token:', error)
    return ''
  }
}

export const verifyFingerprintToken = (token: string): boolean => {
  try {
    return !!token && token.split('.').length === 3
  } catch (error) {
    return false
  }
}
